module.exports = __webpack_public_path__ + "media/images/countrysquared/sj-893a0e21858d72467b0fdb31008d6b1c.svg";